import React, { useEffect, useState } from 'react';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import Company from '../../../components/company';
import { get } from '../../../services/apiController';
import { toast } from 'react-toastify';

const LocationDetail = ({ form, setForm, handleChange }) => {
  const [locationList, setLocationList] = useState([]);

  useEffect(() => {
    get(`/branches`)
      .then((response) => {
        setLocationList(response?.data?.rows);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data?.message || err.message);
      });
  }, []);

  useEffect(() => {
    if (form.branchId && locationList.length > 0) {
      const location = locationList?.find((item) => item.id === +form.branchId);
      setForm((prevForm) => ({
        ...prevForm,
        locationType: location?.type || '',
      }));
    }
  }, [form.branchId, locationList, setForm]);

  return (
    <Row>
      <Col xs={6}>
        <FloatingLabel controlId="floatingSelect" label="Company" className="mb-3">
          <Company disabled required company={form.companyId} name="company" label="Company" />
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingSelect" label="Location Type" className="mb-3">
          <Form.Select required value={form.locationType} name="locationType" onChange={handleChange} className="input mb-2">
            <option value="">Select Location Type</option>
            <option value="office">Office</option>
            <option value="factory">Factory</option>
            <option value="outlet">Outlet</option>
            <option value="staff-room">Staff Room</option>
          </Form.Select>
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingSelect" label="Location" className="mb-3">
          <Form.Select required value={form.branchId} name="branchId" onChange={handleChange} className="input mb-2">
            <option value="">Select Location</option>
            {locationList
              .filter((item) => item?.type === form.locationType)
              .map((item) => (
                <option key={item?.id} value={item?.id}>
                  {item?.name}
                </option>
              ))}
          </Form.Select>
        </FloatingLabel>
      </Col>
      <Col xs={6}>
        <FloatingLabel controlId="floatingInput" label="Reference Location" className="mb-3">
          <Form.Control
            required
            className="input"
            name="referenceLocation"
            value={form.referenceLocation}
            onChange={handleChange}
            type="text"
            placeholder="Reference Location"
          />
        </FloatingLabel>
      </Col>
    </Row>
  );
};

export default LocationDetail;
